export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL
export const DRUPAL_API_URL = process.env.REACT_APP_DRUPAL_API_URL
export const PHENOMENA_STATISTICS_API_URL = process.env.REACT_APP_PHENOMENA_STATISTICS_API_URL
export const TAG_SERVICE_API_URL = process.env.REACT_APP_TAG_SERVICE_API_URL
export const CONTENT_SERVICE_API_URL = process.env.REACT_APP_CONTENT_SERVICE_API_URL